<template>
  <div>
    <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

      <b-form @submit.prevent="save">
        <b-card>
          <b-form-row>
            <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" " :error="$v.form.descricao"
              v-model="form.descricao" label="Descrição:*" cols="12" />
          </b-form-row>

          <b-form-row>

            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
              <b-button  v-b-tooltip.hover.top="'Salvar'" class=" my-2" size="sm" pill variant="success" @click="save">
                <b-icon icon="check-circle" />

              </b-button>

              <b-button  v-b-tooltip.hover.top="'Cancelar'" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
                <b-icon icon="x-circle" />

              </b-button>
            </b-col>
            <b-col cols="3"></b-col>

          </b-form-row>


        </b-card>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      descricao: { required },
    },
  },
  props: {
    id: Number,
    prefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        descricao: "",
      },
      showModal: true,
      title: "Cadastro",


    };
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/tipo-garantia-contrato`);
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    }
  },
  methods: {
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch();
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        });
        return;
      }

      await this.$saveResource(this.form);
      this.cancelar();
    },

    cancelar() {
      this.$emit("close");
    },

  },
};
</script>
